import url from './url'
import logger from './logger'
import userAgent from './userAgent'
import dom from './dom'
import collections from './collections'

export default {
  url,
  logger,
  userAgent,
  dom,
  collections
}



// WEBPACK FOOTER //
// ./src/library/core/index.js